<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <model-create
          class="col-12"
          :loading="loading"
          :storing="storing"
          v-bind="$props"
          v-model="model"
          :errors.sync="errors"
          @back-click="handleBack"
          @store-click="handleStore"
          @model-changed="handleModelChanged"
      >
        <template #card-footer="{ loading, storing, denyBack, handleStore, handleBack }">
          <div class="footer-wrapper">
            <div class="row">
              <div class="col-md-10">
                <div class="row">
                  <div class="col-6" v-if="!is_down_payment">
                    <div class="d-flex align-items-center gap-2">
                      <div class="section-label">
                        GRAND BIOMASSA
                      </div>
                      <div class="flex-grow-1">
                        <b-input-group :append="$t('units.kg')">
                          <numeral-input
                              id="total"
                              :disabled="true"
                              name="total"
                              style="text-align: right"
                              v-model.number="grand_biomassa"
                          />
                        </b-input-group>
                      </div>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="d-flex align-items-center gap-2">
                      <div class="section-label">
                        GRAND TOTAL
                      </div>
                      <div class="flex-grow-1">
                        <numeral-input
                            id="total"
                            :disabled="true"
                            format="$ 0,0.[00]"
                            name="total"
                            :placeholder="lodash.upperFirst($t('purchase_orders.total'))"
                            style="text-align: right"
                            v-model.number="grand_total"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-2 d-flex flex-row-reverse justify-content-start flex-wrap">
                <b-button :disabled="storing" class="ms-2" native-type="submit" variant="primary" @click="handleStore">
                  <i v-if="storing" class="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
                  {{ $t('Store') }}
                </b-button>
                <b-button class="ms-2" v-if="!denyBack" variant="link" @click="handleBack">
                  {{ $t('Back') }}
                </b-button>
              </div>
            </div>
          </div>
        </template>
      </model-create>
    </div>
  </Layout>
</template>
<script>
import ModelCreate from "../models/create-v2";
import FormsModel from "@/components/forms/purchase_orders_bulk";
import {serialize} from "object-to-formdata";
import NumeralInput from "@/components/inputs/numeral.vue";

export default {
  components: {NumeralInput},
  extends: ModelCreate,
  page: {
    title: "Create Purchase Orders",
  },
  props: {
    cardTitle: {
      default() {
        return this.lodash.startCase(this.$t("purchase_orders.singular"));
      },
    },
    resourceRoute: { default: "purchase_orders" },
    modelVariable: { default: "purchase_order" },
    form: {
      default() {
        return FormsModel;
      },
    },
    cardAttrs: {
      default() {
        return {
          class: "purchase-order-card-form",
        };
      },
    },
    formListeners: {
      default() {
        return {
          "model-changed": (purchase_orders) => {
            if(Array.isArray(purchase_orders)){
              const operationalCost = purchase_orders.reduce((acc, curr) => {
                let iceCost = curr.ice_cost || 0;
                let shippingCost = curr.shipping_cost || 0;
                let labourCost = curr.labour_cost || 0;
                let operationalCostTotal =
                    iceCost +
                    shippingCost +
                    labourCost +
                    curr.other_operational_costs?.reduce(
                        (carry, { total }) => carry + (total || 0),
                        0
                    );
                if (curr.shrimp_selected.code === 'harvest') {
                  operationalCostTotal += (curr.total_operational_cost || 0);
                }
                return acc + operationalCostTotal;
              }, 0)

              const grandTotal = purchase_orders.reduce((acc, curr) => {
                if (curr.shrimp_selected.code === 'down_payment') {
                  return acc + curr.down_payment;
                }
                return acc + curr.total;
              }, 0);
              const grandBiomassa = purchase_orders.reduce((acc, curr) => acc + curr.purchase_items?.reduce((acc, curr) => acc + curr.quantity, 0), 0);

              this.grand_total = grandTotal + operationalCost;
              this.grand_biomassa = grandBiomassa;
            }
          },
          "shrimp-changed": (shrimp) => {
            this.is_down_payment = shrimp.code === 'down_payment'
          },
        };
      },
    },
  },
  data() {
    return {
      title: this.lodash.upperFirst(this.$t("purchase_orders.plural")),
      items: [
        {
          text: this.lodash.upperFirst(this.$t("purchase_orders.plural")),
          href: "/purchase_orders",
        },
        {
          text: this.$t("Create New"),
          href: "/purchase_orders/create",
          active: true,
        },
      ],
      grand_total: 0,
      grand_biomassa: 0,
      is_down_payment: false,
    };
  },
  methods: {
    store(value) {
      const isTicketMode = !value.purchase_plan_id;
      const purchase_orders = this.lodash.cloneDeep(value.purchase_orders).map((item) => {
        const {
          shrimp_id,
          customer_id,
          service_fee,
          ticketable,
          duration,
          unit_duration,
          ordered_at,
          farmer_id,
          farm_id,
          feed,
          down_payment,
          estimated_harvest_date,
          actual_invoice_date,
          ice_cost,
          shipping_cost,
          labour_cost,
          other_operational_costs,
          down_payment_documents,
          invoice_documents,
          operational_cost_documents,
          purchase_items,
          additional_fees,
          discounts,
          description,
          shrimp_origin,
          total_operational_cost,
          shrimp_selected,
          mark_up,
        } = item;
        let purchaseOrder = {
          product_id: shrimp_id,
          customer_id: customer_id || value.customer_id,
          hatchery_id: item.hatchery_id,
          service_fee,
          duration,
          unit_duration,
          ordered_at,
          farmer_id,
          farm_id,
          feed,
          down_payment,
          estimated_harvest_date,
          actual_invoice_date,
          shrimp_selected,
          description,
          send_to_rfq: item.send_to_rfq,
        };
        if (isTicketMode) {
          purchaseOrder.ticket_id = ticketable.ticket_id;
          purchaseOrder.ticketable = {id: ticketable, ticket_id: ticketable.ticket_id};
        }
        if (shrimp_selected?.code === 'harvest') {
          purchaseOrder.markup_kg = mark_up;
        }

        purchaseOrder.shrimp_id = value.shrimp_id;
        if (isTicketMode) {
          purchaseOrder.ticketable = value.ticketable;
        }

        let operational_costs =
            other_operational_costs?.filter(({ total }) => total !== 0) ?? [];

        if (ice_cost > 0) {
          operational_costs.push({
            name: "ice",
            total: ice_cost,
          });
        }

        if (shipping_cost > 0) {
          operational_costs.push({
            name: "delivery",
            total: shipping_cost,
          });
        }

        if (labour_cost > 0) {
          operational_costs.push({
            name: "labour",
            total: labour_cost,
          });
        }

        if (operational_costs.length > 0)
          purchaseOrder.purchase_operational_costs_relation = operational_costs.map(v => ({
            name: v.name,
            amount: v.total,
          }));

        let files = [];

        if (shrimp_id === 13) {

          if (down_payment_documents) {
            down_payment_documents.map((file) => {
              if (file.file) {
                files.push({
                  name: "down payment document",
                  file: file.file,
                });
              }
            });
          }
        } else {
          if (invoice_documents) {
            invoice_documents.map((file) => {
              if (file.file) {
                files.push({
                  name: "invoice document",
                  file: file.file,
                });
              }
            });
          }
        }

        if (operational_cost_documents) {
          operational_cost_documents.map((file) => {
            if (file.file) {
              files.push({
                name: "operational cost document",
                file: file.file,
              });
            }
          });
        }

        purchaseOrder.files_relation = files;
        purchaseOrder.purchase_items_relation = purchase_items.map(item => ({
          quality: item.quality,
          doc: item.doc,
          size: item.size,
          quantity: item.quantity,
          unit_price: item.unit_price,
          shrimp_origin,
        }));
        purchaseOrder.purchase_additional_items_relation = additional_fees.map(fee => ({
          name: fee.name,
          total: fee.total,
        }))?.concat(discounts.map((v) => ({
          name: v.name, total: -v.total
        })))
        if (purchaseOrder.shrimp_selected.code === 'down_payment') {
          purchaseOrder.purchase_items = [];
          purchaseOrder.purchase_additional_items_relation = [];
          purchaseOrder.ordered_at = null;
        }else{
          purchaseOrder.down_payment = null;
          purchaseOrder.estimated_harvest_date = null;
          purchaseOrder.service_fee = value.service_fee;
          // purchaseOrder.duration = value.duration;
        }

        if (purchaseOrder.shrimp_selected.code === 'harvest') {
          purchaseOrder.total_operational_cost = total_operational_cost;
        }

        purchaseOrder.odoo_purchase_order_relation = {
          odoo_vendor_id: item.vendor_selection === 'supplier' ? value.customer.odoo_partner_id : item.farmer.odoo_partner_id,
          vendor_selection: item.vendor_selection,
        }

        purchaseOrder.feed_products_relation = item.feed_product_ids?.map(val => ({id: val}))

        return purchaseOrder;
      });

      if (isTicketMode) {
        return this.$axios.post(
            `tickets/${value.ticketable.ticket_id}`,
            serialize(
                { purchase_orders, _method: "PUT" },
                { indices: true, booleansAsIntegers: true },
            )
        );
      }

      return this.$axios.post(
          `v1/purchase_plans/${value.purchase_plan_id}/purchase_orders`,
          serialize(
              { purchase_orders },
              { indices: true, booleansAsIntegers: true },
          )
      );
    },
    storeSuccessAlert() {
      return this.$toast("Nota berhasil disimpan", {
        type: "success",
        timeout: 10000,
      });
    },
    handleStore(value) {
      this.storing = true;
      this.store(value)
      .then((response) => {
        const {
          data: { data },
        } = response;
        localStorage.removeItem("purchase_order_plan");
        localStorage.removeItem("purchase_order_ticket");
        localStorage.removeItem("purchase_order_sales_plan");
        localStorage.removeItem("purchase_order_sales_plan_meta");
        localStorage.removeItem("purchase_order_sales_plan_items");
        this.storeSuccessAlert(this.getModelName(value), (data || {}).id);
        return response;
      })
      .then((response) => {
        this.isEditing = false;
        const purchase_orders = response?.data?.data?.purchase_orders?.map((purchase_order) => (purchase_order?.id?.toString()));
        return this.$router.push({
          name: 'purchase_orders.index',
          params: {
            highlight: purchase_orders,
          }
        })
      })
      .catch((error) => this.failedAlert(error))
      .finally(() => {
        this.storing = false;
      });
    },
    beforeMount() {
      window.onbeforeunload = this.preventNav;
    },
    handleBeforeRouteLeave(to, from, next) {
      if (this.isEditing) {
        if (localStorage.getItem("purchase_order_plan_meta") || localStorage.getItem("purchase_order_ticket_meta") || localStorage.getItem("purchase_order_sales_plan_meta")) {
          if (
              !window.confirm(
                  this.lodash.upperFirst(
                      this.$t("Data tidak tersimpan. Yakin meninggalkan halaman?")
                  )
              )
          ) {
            return;
          }
        }
      }
      localStorage.removeItem("purchase_order_plan_meta");
      localStorage.removeItem("purchase_order_ticket_meta");
      localStorage.removeItem("purchase_order_sales_plan");
      localStorage.removeItem("purchase_order_sales_plan_meta");
      localStorage.removeItem("purchase_order_sales_plan_items");
      next();
    },
  },
};
</script>


<style lang="scss" scoped>
.section-label {
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  color: #0084f3;
}
.footer-wrapper {
  border-top: 1px solid var(--neutral-vst-color-neutral-300, #E6E6E6);
  position: sticky;
  bottom: 0;
  background: white;
}
</style>
